import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-content" }
const _hoisted_2 = { class: "toast-icon" }
const _hoisted_3 = {
  key: 0,
  src: "/icons/icon-success.svg",
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: "/icons/icon-fail.svg",
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  src: "/icons/icon-warning.svg",
  alt: ""
}
const _hoisted_6 = {
  key: 3,
  src: "/icons/icon-info.svg",
  alt: ""
}
const _hoisted_7 = { class: "toast-message" }

import { ref, onMounted, watch } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ToastNotification',
  props: {
    message: {},
    type: {},
    show: { type: Boolean },
    duration: {}
  },
  emits: ['update:show', 'close'],
  setup(__props: any, { emit: __emit }) {

    /* eslint-disable no-undef */
    const props = __props;

    const emit = __emit;

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    watch(() => props.show, (newValue) => {
        if (newValue) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                close();
            }, props.duration || 5000);
        }
    });

    function close() {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        emit('update:show', false);
        emit('close');
    }

    onMounted(() => {
        if (props.show) {
            timeoutId = setTimeout(() => {
                close();
            }, props.duration || 5000);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "toast" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["toast-container", `toast-${_ctx.type}`]),
            onClick: close
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.type === 'success')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : (_ctx.type === 'error')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : (_ctx.type === 'warning')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                      : (_openBlock(), _createElementBlock("img", _hoisted_6))
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.message), 1),
              _createElementVNode("button", {
                class: "toast-close",
                onClick: _withModifiers(close, ["stop"])
              }, "×")
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})